import { ANALYTICS_SET_SESSION_ID, superContentStarted, setSessionId, setPageSessionId } from './analyticActions'
import { trigger, events } from 'aria-viewer/legacy'
import { isReduxBatch } from 'aria-viewer/utils/epicsCommon'
import { Observable } from 'rxjs'
import SocketProxy from './utils/socket/socketProxy'
import Analytics from './utils/analytics'
import { getTourData } from './utils/analyticUtils'

const isAnalyticsSetSessionID = action =>
    (isReduxBatch(action) && action.payload.some(element => element.type == ANALYTICS_SET_SESSION_ID)) ||
    action.type == ANALYTICS_SET_SESSION_ID

const getSessionId = action =>
    action.sessionId
        ? action.sessionId
        : action.payload.find(element => element.type == ANALYTICS_SET_SESSION_ID).sessionId

export default (action$, store) => {
    const setSessionId$ = action$.filter(isAnalyticsSetSessionID)

    const triggerSessionIdChanged$ = setSessionId$.switchMap(action => {
        const sessionId = getSessionId(action)

        trigger(events.sessionIdChanged, { sessionId })

        return Observable.never()
    })

    const isIWC =
        store.getState().getIn(['device', 'isInIframe']) && store.getState().getIn(['device', 'useResponsiveUI'])

    // Handle messages sent from parent window (Smart Script)
    if (isIWC) {
        // Post message to parent to let it know I'm alive
        window.parent.postMessage(`youvisit:trackAnalyticsInit`, '*')

        const message$ = Observable.fromEvent(window, 'message')
            .map(e => e.data)
            .filter(data => typeof data == 'string' && data.startsWith('youvisit:'))

        message$.subscribe(eventMessage => {
            const messageParts = eventMessage.split(':')
            const eventName = messageParts[1]
            const eventData = messageParts[2]

            switch (eventName) {
                case 'trackAnalyticsAck': {
                    // If we've acknowledged that the parent is ready to track analytic events
                    // let's set the proxy isReady to true
                    SocketProxy.isReady = true

                    Analytics.analyticsData.createAnalyticsModuleParams.pageSessionId = eventData

                    store.dispatch(setPageSessionId(eventData))
                    break
                }
                case 'superContentStart': {
                    Analytics.analyticsData.hasInitialized = false
                    store.dispatch(superContentStarted())
                    break
                }
                case 'superContentEnd': {
                    // Reset session id to the original sessionId
                    store.dispatch(setSessionId(Analytics.analyticsData.originalSessionId))

                    // Reset sessionType
                    Analytics.analyticsData.createAnalyticsModuleParams.sessionType = undefined
                    break
                }
                case 'initSessionId': {
                    const sessionId = store.getState().getIn(['analytics', 'sessionId'])

                    Analytics.analyticsData.originalSessionId = sessionId

                    store.dispatch(setSessionId(eventData))

                    Analytics.analyticsData.createAnalyticsModuleParams.sessionType = 'iwc'
                    Analytics.analyticsData.analyticsTime = 0

                    Analytics.initAnalytics()
                    break
                }
                case 'analyticsInitialized': {
                    Analytics.analyticsInitialized()
                    break
                }
                case 'updatePageSessionId': {
                    Analytics.analyticsData.createAnalyticsModuleParams.pageSessionId = eventData
                    store.dispatch(setPageSessionId(eventData))
                    break
                }
                case 'analyticsReinit': {
                    Analytics.initAnalytics(true)
                    break
                }
                default:
                // No need to do anything
            }
        })

        // Let's get the session id and pass this along to the parent window
        setSessionId$.first().subscribe(action => {
            const sessionId = getSessionId(action)
            const {
                loc_id,
                userkey,
                tourid,
                platform,
                owner_id,
                inst_name,
                loc_name,
                stopid,
                stoptitle,
            } = getTourData()(store.getState)

            const analyticData = JSON.stringify({
                sessionId,
                loc_id,
                userkey,
                tourid,
                platform,
                inst_id: owner_id,
                inst_name,
                loc_name,
                stop_id: stopid,
                stop_name: stoptitle,
            })

            // Notify the parent my session id
            window.parent.postMessage(`youvisit:trackAnalyticsReady:${analyticData}`, '*')
        })
    }

    return triggerSessionIdChanged$
}
